import kebabCase from 'lodash/kebabCase';

export const paddedIndex = (i: string | number): string =>
  `${i}`.padStart(4, '0');

export const testIdModifier = (
  block: string,
  element?: string
): {
  index: (i: number, addOne?: boolean) => string;
  id: (id: string) => string;
} => ({
  index: (i: number, addOne = true): string =>
    `${block}${element ? `__${element}` : ''}--${paddedIndex(
      i + (addOne ? 1 : 0)
    )}`,
  id: (id: string): string =>
    `${block}${element ? `__${element}` : ''}--${kebabCase(id)}`,
});

export const testIds = <T extends { [K in keyof T]: string }>(
  block: string,
  elements: T
): {
  COMPONENT: string;
} & { [K in keyof T]: string } => ({
  COMPONENT: kebabCase(block),
  ...Object.entries(elements).reduce(
    (acc: T, [k, v]) => ({
      ...acc,
      [k]: `${kebabCase(block)}__${kebabCase(v as string)}`,
    }),
    {} as T
  ),
});
